import { useParams, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const S3_BASE_URL = "https://nv-age-system.com/installers";

const downloadData = {
  mediasearch: {
    name: "Media Search",
    latest: {
      version: "1.0.0",
      date: "2025-12-01",
      notes: "初回リリース",
      mac: `${S3_BASE_URL}/Media_Search_Installer_v100.pkg`,
      win: `${S3_BASE_URL}/Media_Search_Installer_v100.exe`,
      manual: `${S3_BASE_URL}/Media_Search_User_Manual.pdf`
    },
    old: [
      // {
      // version: "1.0.0",
      // date: "2025-12-01",
      // notes: "初回リリース",
      // mac: `${S3_BASE_URL}/Media_Search_Installer_v100.pkg`,
      // win: `${S3_BASE_URL}/Media_Search_Installer_v100.exe`
      // }
    ]
  },

  markerport: {
    name: "MarkerPort",
    latest: {
      version: "1.0.0",
      date: "2025-12-01",
      notes: "初回リリース",
      mac: `${S3_BASE_URL}/MarkerPort_Installer_v100.pkg`,
      win: ``,
      manual: `${S3_BASE_URL}/MarkerPort_User_Manual.pdf`
    },
    old: [
      // version: "1.0.0",
      // date: "2025-12-01",
      // notes: "初回リリース",
      // mac: `${S3_BASE_URL}/MarkerPort_Installer_v100.pkg`,
      // win: ``,
      // manual: `${S3_BASE_URL}/Media_Search_User_Manual.pdf`
    ]
  }
};

export default function DownloadPage() {
  const { productId } = useParams();
  const location = useLocation();
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const [productName, setProductName] = useState("");

  const product = downloadData[productId];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    const cleanUrl = window.location.pathname;
    window.history.replaceState({}, '', cleanUrl);

    if (!token || !productId || !product) {
      setAuthorized(false);
      setLoading(false);
      return;
    }

    try {
      const decoded = JSON.parse(decodeURIComponent(escape(atob(decodeURIComponent(token)))));
      const { email, licenseKey, product: decodedProduct } = decoded;

      fetch("https://2be73sxme5.execute-api.ap-northeast-1.amazonaws.com/DownloadStage/login_download", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ CustomerEmail: email, LicenseKey: licenseKey, A1_ProductName: decodedProduct })
      })
        .then(res => res.json())
        .then(data => {
          setAuthorized(data.valid);
          setProductName(decodedProduct);
          setLoading(false);
          document.title = `${decodedProduct} インストーラー`;
        })
        .catch(err => {
          console.error("Fetch error:", err);
          setLoading(false);
        });
    } catch (err) {
      console.error("Invalid token:", err);
      setLoading(false);
    }
  }, [location, productId]);

  if (loading) {
    return (
      <div className="container">
        <h1 className="title">読み込み中</h1>
        <p style={{ fontSize: '14px', color: '#999', textAlign: 'center' }}>
          しばらくお待ちください...
        </p>
      </div>
    );
  }

  if (!authorized) {
    return (
      <div className="container">
        <h1 className="title">このページにはアクセスできません</h1>
        <p style={{ fontSize: '14px', color: '#999', textAlign: 'center' }}>
          ※製品からの遷移のみ許可されています。
        </p>
      </div>
    );
  }

  return (
    <div className="container">
      <h1 className="title-download">{productName} インストーラー</h1>

      <div className="section">
        <h3 className="subtitle">最新バージョン</h3>
        <div className="button-group-download">

          {product.latest.mac && (
            <a className="action-button-download mac" href={product.latest.mac} download>
              Mac / ver.{product.latest.version} ダウンロード
            </a>
          )}

          {product.latest.win && (
            <a className="action-button-download win" href={product.latest.win} download>
              Win / ver.{product.latest.version} ダウンロード
            </a>
          )}

        </div>
      </div>

      {product.old.length > 0 && (
        <div className="section">
          <h3 className="subtitle">旧バージョン</h3>
          {product.old.map((v, idx) => (
            <div className="button-group-download" key={idx}>

              {v.mac && (
                <a className="action-button-download mac" href={v.mac} download>
                  Mac / ver.{v.version} ダウンロード
                </a>
              )}

              {v.win && (
                <a className="action-button-download win" href={v.win} download>
                  Win / ver.{v.version} ダウンロード
                </a>
              )}

            </div>
          ))}
        </div>
      )}

      <div className="section">
        <h3 className="subtitle">バージョン情報</h3>
        <div className="version-text">
          <strong>ver.{product.latest.version}（{product.latest.date}）</strong><br />
          ・{product.latest.notes}<br /><br />
          {product.old.map((v, idx) => (
            <div key={idx}>
              <strong>ver.{v.version}（{v.date}）</strong><br />
              ・{v.notes}<br /><br />
            </div>
          ))}
        </div>
      </div>

      <div className="section">
        <h3 className="subtitle">マニュアル</h3>
        <div className="button-group-download" style={{ justifyContent: "center" }}>
          <a className="action-button-download manual" href={product.latest.manual} download>
            マニュアル ダウンロード
          </a>
        </div>
      </div>
    </div>
  );
}
